// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "a[data-v-1b17e7bf]{color:#1976d2}.page .sidebar[data-v-1b17e7bf]{grid-row:1/span 1;margin-top:1.5rem}@media (min-width: 768px){.page .sidebar[data-v-1b17e7bf]{margin-top:2.5rem}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
